import FormViewComponents from './formView.vue'

const formView = {
  install: function (Vue) {
    Vue.component('FormView', FormViewComponents)
  }
}

export default formView
